import { QueryAction } from "../enums/action.enum";
import { ApiTypeEnum } from "../enums/api-type.enum";
import { QuerySource } from "../enums/source.enum";

const meta = {
  type: "user",
  source: QuerySource.Web,
};

 
 
const getApiVariable = (action, data, refine, extraData, type) => {
  if (type === ApiTypeEnum.Other || action === QueryAction.GET) {
    return {
      meta: {
        action,
        ...meta,
      },
      ...data,
      refine: {
        ...refine,
      },
    };
  } else if (action === QueryAction.CREATE_WALLET) {
    return {
      [type]: {
        ...data,
      },
    };
  } else if ((type === ApiTypeEnum.noMetaType)) {
    return {
      ...data,
    };
  } else {
    return {
      [type]: {
        meta: {
          action,
          ...meta,
        },
        domain: {
          ...data,
        },
      },
      ...extraData,
    };
  }
};

export default getApiVariable